import toast, { Toast } from 'react-hot-toast';

import {
  ModifiedToastOptions,
  PromiseMessages,
} from '@/shared/types/global/notify-service.types.ts';

const DEFAULT_ARIA_PROPS = {
  'aria-details': 'info',
  'aria-live': 'polite',
  role: 'status',
} as const;

class NotifyService {
  custom(content: (t: Toast) => JSX.Element | string, options?: ModifiedToastOptions): void {
    toast.custom(t => content(t), options);
  }

  error(message: JSX.Element | string, options?: ModifiedToastOptions): void {
    toast.error(message, {
      ariaProps: {
        ...DEFAULT_ARIA_PROPS,
        'aria-details': 'error',
      },
      ...options,
    });
  }

  info(message: JSX.Element | string, options?: ModifiedToastOptions): void {
    toast(message, {
      ariaProps: {
        ...DEFAULT_ARIA_PROPS,
      },
      ...options,
    });
  }

  loading(message: JSX.Element | string, options?: ModifiedToastOptions): void {
    toast.loading(message, {
      ariaProps: {
        ...DEFAULT_ARIA_PROPS,
        'aria-details': 'loading',
      },
      ...options,
    });
  }

  async promise(
    promise: Promise<unknown>,
    messages: PromiseMessages,
    options?: ModifiedToastOptions,
  ): Promise<void> {
    await toast.promise(promise, messages, {
      ariaProps: {
        ...DEFAULT_ARIA_PROPS,
        'aria-details': 'request in progress',
      },
      ...options,
    });
  }

  success(message: JSX.Element | string, options?: ModifiedToastOptions): void {
    toast.success(message, {
      ariaProps: {
        ...DEFAULT_ARIA_PROPS,
        'aria-details': 'success',
      },
      ...options,
    });
  }
}

export const notifyService = new NotifyService();
